import { render } from "./BasePageHeader.vue?vue&type=template&id=57caa43a&scoped=true"
const script = {}

import "./BasePageHeader.vue?vue&type=style&index=0&id=57caa43a&lang=scss&scoped=true"

import exportComponent from "C:\\Projekte\\wordpress\\eh3\\wp-content\\themes\\io.shop-standalone-energiehoch3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57caa43a"]])

export default __exports__